/**
 * Generated by orval 🍺
 * Do not edit manually.
 * qcs control-plane
 * OpenAPI spec version: 0.1.0
 */

/**
 * A flow a job runs: a scrape, or maintenance of the ClickHouse read model.
 *
 * Lives here (beside :class:`Platform`) rather than in the control plane so that
 * ``core``, the platform registry and the flow engines, can type against it
 * without importing from ``services`` (``core`` must stay app-agnostic). It is
 * re-exported from ``qcs.services.control_plane.db.models`` so the OpenAPI schema and
 * the generated frontend ``flow.ts`` are unchanged.
 */
export type Flow = typeof Flow[keyof typeof Flow];


export const Flow = {
  cart_inventory: 'cart_inventory',
  merchant_sweep: 'merchant_sweep',
  brand_sweep: 'brand_sweep',
  store_sku_map: 'store_sku_map',
  taxonomy_classify: 'taxonomy_classify',
  product_match: 'product_match',
  shelf_id_resolve: 'shelf_id_resolve',
  search_rank: 'search_rank',
  category_rank: 'category_rank',
  availability_build: 'availability_build',
  availability_rebuild: 'availability_rebuild',
  availability_backfill: 'availability_backfill',
} as const;
